module.exports = __webpack_public_path__ + "static/media/ICON_FREE_TRIAL_ACTIVE.6ce6c40d.svg";